import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AnnulerClotureButton from './AnnulerClotureButton';

class AnnulerClotureButtonContainer extends React.Component {
    render() {
        const { isCancelCloture, onClick } = this.props;

        return (
            <AnnulerClotureButton
                onClick={onClick}
                isCancelCloture={isCancelCloture}
            />
        );
    }
}

const mapStateToProps = state => ({
    isCancelCloture: state.reclamation.reclamations.isCancelCloture
});

AnnulerClotureButtonContainer.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default connect(mapStateToProps, null)(AnnulerClotureButtonContainer);